import angular from 'angular';

import component from './kitchens-list.component';
import service from './kitchens-list.service';

export default angular
    .module('control-room.menus.components.kitchens-list', [])
    .component('crKitchensList', component)
    .service('crKitchensListService', ['crEntityService', 'crConstants', service]);
